/**
 * Provides variations from a Guidewire service
 *
 * getExperimentVariant {Promise}
 *      It fulfils with a selected option for the user.
 *      E.g. 0 or 1. In case of an error -1 is returned
 *      The value is persisted in cookies
 */

define([], ()=> {
    return ['JsonRPCService', '$cookies', 'gwAbExperimentxCenter', '$q', (JsonRPCService, $cookies, abExperimentxCenter, $q)=> {
        return {
            /**
             * @param [experimentId] {String}
             * @param [params] {Object}
             * @returns {Promise}
             */
            getExperimentValue(experimentId = 'guidewireExperiment', params) {
                // check experiment ID in cookies
                if ($cookies.get(experimentId)) {
                    return $q.resolve($cookies.get(experimentId));
                }
                // get experiment variant
                return JsonRPCService
                    .send(abExperimentxCenter, 'segmentation/abexperiment', 'getExperimentValue', [experimentId, params])
                    .then((data)=> {
                        $cookies.put(experimentId, data.experimentResponse);// put experiment variant in cookies
                        return data.experimentResponse;
                    }, ()=> {
                        return -1;
                    });
            }
        };
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/segmentation/abexperiment/providers/DemoGuidewireExperiment.js